import { useEffect, useState } from "react";
import { checkEmpty, checkEmptyObj, checkIf, checkUndefined } from "../../utils";
import moment from "moment";

export interface IValidateEntity {
  error?: boolean;
  helperText?: string;
  dirty?: boolean;
}
export interface TransactionValidation {
  transactionType: string;
  operationType: string;
  paymentType: string;
  amount: number;
}

export interface IValidate {
  show?: boolean;
  error?: boolean;
  dirty?: boolean;
  message?: string;
  transactionType?: IValidateEntity;
  operationType?: IValidateEntity;
  paymentType?: IValidateEntity;
  amount?: IValidateEntity;
}

export default function useTransactionValidation(validationInfo: TransactionValidation) {
  const [validation, setValidation] = useState<IValidate>({
    show: false,
    error: false,
    dirty: false,
    message: "",
  });

  useEffect(() => {
    if (!checkIf(validationInfo) || checkEmptyObj(validationInfo)) {
      return;
    }

    setValidation((state) => {
      let newState = { ...state } as IValidate;
      if (Object.keys(validation).length === 4) {
        let fields: any = {};
        Object.keys(validationInfo).forEach((item: string) => {
          const value = validationInfo[item as keyof TransactionValidation];
          fields[item] = { error: false, helperText: "" };
        });
        newState = { ...newState, ...fields };
      }

      newState.error = false;

      if (!checkUndefined(validationInfo.transactionType)) {
        if (checkEmpty(validationInfo?.transactionType) || !checkIf(validationInfo?.transactionType)) {
          newState.transactionType!.error = true;
          newState.transactionType!.helperText = "Please select a transaction type";
          newState.error = true;
        } else {
          newState.transactionType!.error = false;
        }
      }

      if (!checkUndefined(validationInfo.paymentType)) {
        if (checkEmpty(validationInfo?.paymentType) || !checkIf(validationInfo?.paymentType)) {
          newState.paymentType!.error = true;
          newState.paymentType!.helperText = "Please select a payment type";
          newState.error = true;
        } else {
          newState.paymentType!.error = false;
        }
      }

      if (!checkUndefined(validationInfo.amount)) {
        if (checkEmpty(validationInfo?.amount) || !checkIf(validationInfo?.amount)) {
          newState.amount!.error = true;
          newState.amount!.helperText = "Amount cannot be empty";
          newState.error = true;
        } else {
          let hasError = false;
          let message = "";
          const regex = new RegExp("^d+(.d{1,2})?$");

          const numberRegex = /^\d+(\.\d{1,3})?$/;
          let test = Boolean(validationInfo.amount!.toString().match(numberRegex));

          if (test) {
            if (validationInfo.amount! < 1) {
              message = "Amount cannot be less than one";
              hasError = true;
            } else if (validationInfo.amount! > 25000) {
              hasError = true;
              message = "Amount cannot be more than 25000";
            } else {
              hasError = false;
            }
          } else {
            message = "Amount must include numeric characters";
            hasError = true;
          }
          newState.amount!.error = hasError;
          newState.amount!.helperText = message;
          if (hasError) newState.error = true;
        }
      }

      return newState;
    });
  }, [validationInfo]);
  return { validation, setValidation };
}
